import React from 'react'
import { Flex, Text } from '@chakra-ui/react'
import { AuthorInfo, Blog, blogAuthorName } from 'entities/blog'
import { toShortAndLongDates } from 'lib/date'
import { Avatar } from 'components/images/Avatar'

type BlogInfoProps = Pick<Blog, 'creationDate' | 'updated' | 'readingTime' | 'author'> & {
    authorInfo?: Pick<AuthorInfo, 'name' | 'imageUrl'>
}

export function BlogInfo(props: BlogInfoProps) {
    const { creationDate, updated, readingTime, authorInfo } = props

    const publishedDate = updated ? updated : creationDate
    const [shortDisplayDate] = toShortAndLongDates(publishedDate)

    return (
        <Flex gridGap={{ base: '8px', md: '12px' }} alignItems="center">
            {authorInfo && <Avatar src={authorInfo.imageUrl} boxSize={'48px'} />}
            <Flex flexDirection="column" gridGap={{ base: '4px', md: '5px' }}>
                <Text
                    fontWeight="600"
                    fontSize={{ base: '16px', md: '18px' }}
                    lineHeight="18px"
                    noOfLines={1}
                >
                    {blogAuthorName(props)}
                </Text>
                <Flex gridGap={{ base: '6px', md: '10px' }}>
                    <Text
                        fontSize={{ base: '13px', md: '16px' }}
                        lineHeight={{ base: '18px', md: '24px' }}
                        color="text.secondary"
                        noOfLines={1}
                    >
                        {shortDisplayDate}
                    </Text>
                    <Text
                        fontSize={{ base: '18px', md: '24px' }}
                        lineHeight={{ base: '16px', md: '21px' }}
                        w={{ base: '4px', md: '6px' }}
                        ml={{ base: '-1px', md: '-1.5px' }}
                        color="text.secondary"
                    >
                        {'•'}
                    </Text>
                    <Text
                        fontSize={{ base: '13px', md: '16px' }}
                        lineHeight={{ base: '18px', md: '24px' }}
                        color="text.secondary"
                        flexShrink={0}
                        whiteSpace="nowrap"
                    >
                        {`${readingTime} min read`}
                    </Text>
                </Flex>
            </Flex>
        </Flex>
    )
}
